import PropTypes from "prop-types";
import {
    Link

} from "react-router-dom";
import styles from "./Movie.module.css";




function Movie({ id, title, year, summary, genres, coverImg, rating }) {
    function StarRating({ rating }) {
        const fullStars = Math.floor(rating);
        const partialStar = Math.round((rating % 1) * 10); // 1부터 9까지, 소수점 별점
        const emptyStars = 10 - fullStars - (partialStar > 0 ? 1 : 0);
        const partialStarColors = {
            1: '#fffae6',
            2: '#fff5cc',
            3: '#fff0b3',
            4: '#ffeb99',
            5: '#ffe680',
            6: '#ffe066',
            7: '#ffdb4d',
            8: '#ffd633',
            9: '#ffd11a',
        };

        return (
            <div>
                {[...Array(fullStars)].map((_, i) => (
                    <span key={`full-${i}`} className="star full-star" style={{ color: 'gold' }}>&#9733;</span>
                ))}
                {partialStar > 0 && (
                    <span key="partial" className="star" style={{ color: partialStarColors[partialStar] }}>&#9733;</span>
                )}
                {[...Array(emptyStars)].map((_, i) => (
                    <span key={`empty-${i}`} className="star empty-star">&#9734;</span>
                ))}
            </div>
        );
    }


    return (<div className={styles.movie}>
        <img src={coverImg} alt={title} className={styles.movie__img} />
        <div>
            <h2 className={styles.movie__title}>
                <Link to={`/movie/${id}`}>{title}</Link>
            </h2>
            <h3 className={styles.movie__year}>{year} ({rating}) </h3>
            <StarRating rating={rating} />
            <p>{summary.length > 235 ? `${summary.slice(0, 235)}...` : summary}</p>
            <ul className={styles.movie__genres}>
                {genres.map((g) => (
                    <li key={g}>{g}</li>
                ))}
            </ul>
        </div>
    </div>)
}

Movie.propTypes = {
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    year: PropTypes.number.isRequired,
    summary: PropTypes.string.isRequired,
    genres: PropTypes.arrayOf(PropTypes.string).isRequired,
    medium_cover_image: PropTypes.string.isRequired,
    rating: PropTypes.number.isRequired,
}
export default Movie;